import { StytchSDKAPIError } from '@stytch/core/public';

import { toI18n } from 'util/i18n';

import {
  AuthError,
  ResetPasswordError,
  TOO_MANY_REQUESTS_ERROR,
  TOO_MANY_REQUESTS_ERROR_MESSAGE,
} from './constants';

export const credentialErrorCategory = (error: StytchSDKAPIError) => {
  if (!error) return null;
  const { error_type, status_code } = error;

  switch (status_code) {
    case 400:
      if (error_type === 'reset_password') return AuthError.RESET_PASSWORD;
      return AuthError.FORMAT;
    case 401:
    case 403:
    case 404:
      return AuthError.INVALID_CREDENTIALS;
    case 429:
      return TOO_MANY_REQUESTS_ERROR;
    default:
      return AuthError.GENERAL;
  }
};

export const codeAuthErrorCategory = (error: StytchSDKAPIError) => {
  if (!error) return null;
  switch (error.status_code) {
    case 400:
    case 403:
    case 404:
      if (error.error_type === 'ad_blocker_detected')
        return AuthError.AD_BLOCKER_DETECTED;
      return AuthError.INVALID_CREDENTIALS;
    case 401:
      return AuthError.PASSCODE_USED_OR_EXPIRED;
    case 429:
      return TOO_MANY_REQUESTS_ERROR;
    default:
      return AuthError.GENERAL;
  }
};

export const mapAuthenticatePasswordErrorToMessage = (
  error: StytchSDKAPIError
) => {
  const errorType = credentialErrorCategory(error);
  switch (errorType) {
    case AuthError.FORMAT:
      return {
        fieldError: toI18n('fe_design_base.errors.field.email_invalid'),
      };
    case AuthError.RESET_PASSWORD:
      return {
        alertError: toI18n('authentication.errors.reset_password'),
      };
    case AuthError.INVALID_CREDENTIALS:
      return {
        alertError: toI18n('authentication.errors.email_login_invalid'),
      };
    case TOO_MANY_REQUESTS_ERROR:
      return {
        alertError: TOO_MANY_REQUESTS_ERROR_MESSAGE,
      };
    case AuthError.GENERAL:
    default:
      return {
        alertError: toI18n('fe_design_base.errors.general'),
      };
  }
};

export const mapAuthenticateCodeErrorToMessage = (error: StytchSDKAPIError) => {
  const errorType = codeAuthErrorCategory(error);
  switch (errorType) {
    case AuthError.AD_BLOCKER_DETECTED:
      return toI18n('authentication.errors.code_ad_blocker_detected');
    case AuthError.INVALID_CREDENTIALS:
      return toI18n('authentication.errors.code_invalid');
    case AuthError.PASSCODE_USED_OR_EXPIRED:
      return toI18n('authentication.errors.code_used_expired');
    case TOO_MANY_REQUESTS_ERROR:
      return TOO_MANY_REQUESTS_ERROR_MESSAGE;
    case AuthError.GENERAL:
    default:
      return toI18n('fe_design_base.errors.general');
  }
};

export const mapResetPasswordErrorToMessage = (error: StytchSDKAPIError) => {
  switch (error?.error_type) {
    case ResetPasswordError.BREACHED_PASSWORD:
      return toI18n('authentication.errors.breached_password');
    case ResetPasswordError.SESSION_TOO_OLD_TO_RESET_PASSWORD:
      return toI18n('authentication.errors.session_too_old_to_reset_password');
    case TOO_MANY_REQUESTS_ERROR:
      return TOO_MANY_REQUESTS_ERROR_MESSAGE;
    default:
      return toI18n('fe_design_base.errors.general');
  }
};
